var _rect, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 89,
    height: 60,
    viewBox: "0 0 89 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.23595,
    y: 0.580385,
    width: 86.4,
    height: 58.8392,
    rx: 6.38424,
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.16077
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9297 43.4525C41.9487 46.0231 38.0819 47.575 33.8565 47.575C24.4283 47.575 16.7852 39.8486 16.7852 30.3175C16.7852 20.7865 24.4283 13.0601 33.8565 13.0601C38.0819 13.0601 41.9488 14.612 44.9298 17.1827C47.9108 14.612 51.7776 13.0602 56.003 13.0602C65.4312 13.0602 73.0743 20.7866 73.0743 30.3176C73.0743 39.8487 65.4312 47.5751 56.003 47.5751C51.7776 47.5751 47.9107 46.0232 44.9297 43.4525Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9298 43.4527C48.6003 40.2873 50.9278 35.5773 50.9278 30.3178C50.9278 25.0582 48.6003 20.3482 44.9298 17.1829C47.9108 14.6122 51.7776 13.0603 56.003 13.0603C65.4312 13.0603 73.0743 20.7867 73.0743 30.3178C73.0743 39.8488 65.4312 47.5752 56.003 47.5752C51.7776 47.5752 47.9108 46.0233 44.9298 43.4527Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.9298 43.4525C48.6003 40.2872 50.9278 35.5772 50.9278 30.3177C50.9278 25.0582 48.6003 20.3482 44.9298 17.1829C41.2593 20.3482 38.9319 25.0582 38.9319 30.3177C38.9319 35.5772 41.2593 40.2872 44.9298 43.4525Z",
    fill: "#FF5E00"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.ffc60d12ab0c825498557ea1375584c9.svg";
export { ForwardRef as ReactComponent };